module.exports = __webpack_public_path__ + "static/media/1.2812a1c9.jpg";